import { useCallback } from "react";
import { useLanguageCodeMasterSelector } from "../redux/selector";

function useRedirect() {
  const languageCode = useLanguageCodeMasterSelector();

  return useCallback(
    (redirectLink: string, message?: string, type?: "info" | "error") => {
      if (message) {
        window.location.href = `${redirectLink}?type=${
          type || "info"
        }&message=${encodeURI(message)}`;
        return;
      }
      window.location.href = languageCode
        ? `/${languageCode}${redirectLink}`
        : redirectLink;
    },
    [languageCode]
  );
}

export default useRedirect;
